import i18n from '@/i18n';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schemaJson?: object;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = "website",
  ogImage,
  schemaJson,
  articlePublishedTime,
  articleModifiedTime,
}: SEOHeadProps) {
  const fullTitle = `${title} | hlw 平台`;
  const defaultImage = "https://readdy.ai/api/search-image?query=Modern%20minimalist%20technology%20platform%20branding%20with%20abstract%20geometric%20patterns%20and%20warm%20gradient%20accents%2C%20clean%20professional%20design%2C%20soft%20atmospheric%20lighting%2C%20tech%20company%20visual%20identity&width=1200&height=630&seq=hlw-og-default&orientation=landscape";
  const siteUrl = "https://www.hlw.com";

  const structuredData = schemaJson
    ? JSON.stringify(schemaJson)
    : JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "hlw 平台",
        url: siteUrl,
        description: description,
        inLanguage: "zh-CN",
      });

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={`${siteUrl}${canonicalUrl}`} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${siteUrl}${canonicalUrl}`} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage || defaultImage} />
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:site_name" content="hlw 平台" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage || defaultImage} />

      <meta name="geo.region" content="CN-BJ" />
      <meta name="geo.placename" content="北京市" />
      <meta name="geo.position" content="39.9042;116.4074" />

      {articlePublishedTime && <meta property="article:published_time" content={articlePublishedTime} />}
      {articleModifiedTime && <meta property="article:modified_time" content={articleModifiedTime} />}

      <script type="application/ld+json">{structuredData}</script>
    </>
  );
}